import Accordion from "../Assets/Accordion/Accordion"
import moment from "moment"
import { FC, ReactElement, useMemo } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
import { IOrderReview } from "../../types/content"
import StarsRating from "../Assets/StarsRating/StarsRating"
import InformationRow from "./assets/InformationRow"
import useWindowSize from "../../hooks/useWindowSize"
import { PlusIcon } from "../../icons/PlusIcon"
import ScrollBlock from "../Assets/ScrollBlock"
import { GetUserAvatar } from "../Assets/GetUserAvatar/GetUserAvatar"
import styles from "./OrderDescripton.module.scss"
import Coordinators from "../Coordinators/Coordinators"
import { IServiceOrderWithReview } from "../../types/orderTypes"
import CoordinationStatusLabel from "../Coordinations/CoordinationStatusLabel/CoordinationStatusLabel"
import LabelInfo from "../Assets/LabelInfo/LabelInfo"
import { getApiUrl } from "../../utils/getApiUrl"
import PreviewFile from "../Assets/PreviewFile/PreviewFile"
import UserAvatars from "../Assets/UserAvatars/UserAvatars"
import { ProgressCircle } from "../../icons/ProgressCircle"
import { CrossIcon } from "../../icons/CrossIcon"
import { DoubleCheckIcon } from "../../icons/DoubleCheckIcon"
import { useParams, useSearchParams } from "react-router-dom"

interface IListTemplate {
  name: string
  val: string
  layout?: "active" | "history"
}

const listTemplate: IListTemplate[] = [
  {
    name: "applicant",
    val: "orderer_info",
  },
  {
    name: "assignees",
    val: "hasReview",
    layout: "history",
  },
  {
    name: "object",
    val: "TechnicalObject",
  },
  {
    name: "date",
    val: "created_at",
  },
  {
    name: "orderTime",
    val: "created_at",
  },
  {
    name: "orderTimeEnd",
    val: "finished_at",
  },
  {
    name: "orderNum",
    val: "number",
  },
  {
    name: "options",
    val: "options",
  },
]

interface Props {
  order: IServiceOrderWithReview
  layout?: "active" | "history" | "coordination"
  isLoading?: boolean
  review?: IOrderReview[]
}

const formatedName = (name: string) => {
  const arr = name.split(" ")

  return arr.length > 1 ? `${arr[0]} ${arr[1][0]}.` : `${arr}`
}

const OrderDescription: FC<Props> = ({ order, layout, isLoading, review }) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const { t: tStatus } = useTranslation("translation", { keyPrefix: `interface.orderStatus` })
  const { isDesktop } = useWindowSize()
  const { project_id } = useParams()
  const [searchParams] = useSearchParams()

  const isViewCoordinationLabel = useMemo(() => {
    return layout !== "history" && !!order?.approval_status && order?.status === 0
  }, [layout, order])

  const list = useMemo(() => {
    if (isLoading || !order) return null
    return listTemplate.map((item) => {
      if (item.layout && item.layout !== layout) return null
      if (!(item.val in order)) return null
      let txt, labelStatus

      if (item.name === "options") {
        return order.options.map((optionItem) => {
          switch (optionItem.type) {
            case "information": {
              return <></>
              // return <InformationRow el={optionItem} key={optionItem.id} />
            }
            case "text":
            case "number":
            case "formula":
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <p className={styles.rowTxt}>{optionItem.value}</p>
                </li>
              )
            case "boolean":
            case "checkbox":
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <p className={styles.rowTxt}>{optionItem.value ? t("yes") : t("no")}</p>
                </li>
              )
            case "datetime":
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <p className={styles.rowTxt}>
                    {optionItem.value &&
                      (typeof optionItem.value === "number"
                        ? moment(Number(optionItem.value)).format("DD MMMM YYYY HH:mm")
                        : moment(optionItem.value).format("DD MMMM YYYY"))}
                  </p>
                </li>
              )
            case "directory":
            case "list": {
              const items = optionItem.items
                ? optionItem.items.map((optI: any, ind: number) => {
                    if (optionItem?.items?.length) {
                      return optI.name + (ind !== optionItem.items.length - 1 ? ", " : "")
                    }
                    return optI.name
                  })
                : null
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <p className={styles.rowTxt}>{items}</p>
                </li>
              )
            }
            case "photo": {
              const projectID = order?.project_id || project_id || searchParams.get("project_id")
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <div className={styles["photo-block"]}>
                    {optionItem.images &&
                      optionItem.images.map((el, index) => (
                        <div key={index} className={styles["photo-block__preview"]}>
                          <img src={getApiUrl() + "/public/photo/" + el + "?project_id=" + projectID} alt="" />
                        </div>
                      ))}
                  </div>
                </li>
              )
            }
            case "attachment":
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <div className={styles["file-block"]}>
                    {optionItem.files &&
                      optionItem.files.map((el) => <PreviewFile key={el.id} {...el} projectID={order?.project_id} />)}
                  </div>
                </li>
              )
            case "qr":
              return (
                <li key={optionItem.id} className={styles.row}>
                  <h6 className={styles.rowTitle}>{optionItem.name}</h6>
                  <p className={styles.rowTxt}>
                    {optionItem.value &&
                      (typeof optionItem.value === "number"
                        ? moment(Number(optionItem.value)).format("DD MMMM YYYY HH:mm")
                        : moment(optionItem.value, "DD.MM.YYYY HH:mm").format("DD MMMM YYYY HH:mm"))}
                  </p>
                </li>
              )
            default:
              return null
          }
        })
      }
      switch (item.name) {
        case "applicant":
          // Заявитель
          if (!order?.orderer_info?.name) return null
          return (
            <li key={item.name} className={styles.orderer}>
              <h6 className={styles.rowTitle}>{t(item.name)}</h6>
              <div className={styles.orderer__wrap}>
                <GetUserAvatar
                  name={order.orderer_info.name}
                  avatar={order.orderer_info?.avatar}
                  size={isDesktop ? "sm" : "smd"}
                />
                <p className={styles.orderer__name}>{order.orderer_info.name}</p>
              </div>
            </li>
          )
        case "assignees":
          if (!order.hasReview) return null
          if (order.assignees?.length > 1) {
            return (
              <li key={item.name} className={styles.assignee}>
                <p className={styles.assignee__listTitle}>{t("executors")}</p>
                <div className={styles.assignee__wrap}>
                  <UserAvatars items={order.assignees} />
                  <div>
                    {review && review?.length > 0 ? (
                      <StarsRating disabled rating={review[0].rating} />
                    ) : order.score ? (
                      <StarsRating disabled rating={order.score} />
                    ) : null}
                  </div>
                </div>
                <p className={styles.assignee__names}>
                  {order.assignees.map((assignee, index) => {
                    const lastElement = index === order.assignees.length - 1
                    const suffix = lastElement ? "" : ", "
                    if (index >= 5) {
                      if (!lastElement) return null
                      return t("andMore") + " " + (index - 4) + "..."
                    }
                    return assignee.name + suffix
                  })}
                </p>
              </li>
            )
          }

          return (
            <li key={item.name} className={styles.assignee}>
              <div className={styles.assignee__wrap}>
                <div className={styles.assignee__info}>
                  <p className={styles.assignee__name}>
                    {order?.assignees[0]?.name ? formatedName(order?.assignees[0]?.name) : t("executorNotFound")}
                  </p>
                  {review && review?.length > 0 ? (
                    <StarsRating disabled rating={review[0].rating} />
                  ) : order.score ? (
                    <StarsRating disabled rating={order.score} />
                  ) : null}
                </div>
                {order.assignees?.length > 0 && (
                  <GetUserAvatar
                    name={order.assignees[0].name}
                    avatar={order.assignees[0].avatar_id}
                    className={clsx(styles.assignee__avatar)}
                    size={"xmd"}
                  />
                )}
              </div>
            </li>
          )
        case "date":
          txt = moment(order.created_at).format("DD MMMM YYYY")
          if (order?.status_info?.alias) {
            let labelColor: "danger" | "success" | undefined = undefined

            switch (order.status_info.alias) {
              case "suspended":
                labelColor = "danger"
                break
              case "cancelled":
                labelColor = "danger"
                break
              case "resolved":
                labelColor = "success"
                break
              default:
                break
            }

            labelStatus = <LabelInfo txt={order.status_info.name} color={labelColor} className={`${styles.labelInfo} ${styles.statusInfo}`} />
          }
          break
        case "orderTime":
          txt = moment(order.created_at).format("kk:mm")
          break
        case "orderTimeEnd": {
          txt = order?.planed_end_date ? moment(order.planed_end_date * 1000).format("DD MMMM YYYY kk:mm") : null
          break
        }
        default:
          // @ts-ignore
          txt = order[item.val]
      }

      if (!txt) return null

      return (
        <li key={item.name} className={styles.row}>
          <h6 className={styles.rowTitle}>{t(item.name)}</h6>
          <p className={styles.rowTxt}>{txt}</p>
          {item.name === "date" && order?.status_alias && labelStatus}
        </li>
      )
    })
  }, [order, review, layout, isLoading, isDesktop])

  const approvalBlock = useMemo(() => {
    if (!order?.approvals?.length || order?.approvals.every((approval: any) => approval.assignees.length === 0)) {
      return null
    }

    let title: string | ReactElement = t("coordination")
    let addedClass = ""

    if (order?.approval_status) {
      switch (order.approval_status) {
        case "approved":
          title = (
            <>
              <DoubleCheckIcon />
              <span>{t("approved")}</span>
            </>
          )
          addedClass = "res"
          break
        case "denied":
          title = (
            <>
              <CrossIcon />
              <span>{t("rejected")}</span>
            </>
          )
          addedClass = "rej"
          break
        case "in_progress":
          title = (
            <>
              <ProgressCircle />
              <span>{t("coordinationIsProgress")}</span>
            </>
          )
          addedClass = "load"
          break
        default:
          title = t("coordination")
      }
    }

    return (
      <Accordion
        header={
          <span className={clsx(styles["approval-title"], addedClass && styles[`approval-title--${addedClass}`])}>
            {title}
          </span>
        }
        className={clsx(styles["order-descr-accord"], styles["coordination-accordion"])}
      >
        <Coordinators approveSteps={order.approvals} />
      </Accordion>
    )
  }, [order?.approval_status, order?.approvals])

  if (isLoading) return <div className={clsx(styles["description--is-loading"], "skeletonBlock")} />

  return (
    <div className={styles.description}>
      {isDesktop ? (
        <ScrollBlock hideTracksWhenNotNeeded autoHeightMax={["active", "history"].includes(layout || "") ? 520 : 500}>
          <Accordion header={t("description")} className={styles["order-descr-accord"]}>
            <ul className={styles.list}>{list}</ul>
          </Accordion>
          {approvalBlock}
        </ScrollBlock>
      ) : (
        <div className={styles["order-descr-container"]}>
          <ul className={styles.list}>{list}</ul>
          {approvalBlock}
        </div>
      )}
    </div>
  )
}

export default OrderDescription
